import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e54f396"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["dsf_title"]
const _hoisted_2 = ["onClick"]

import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { analytics } from '@/services/analyticsProvider'
import { i18n } from '@/services/i18n'
import { getStateFeatureFlags } from '@/store/getters'
import { ref, computed } from 'vue'

const estBannerLS = 'est_banner_dismissed'


export default /*#__PURE__*/_defineComponent({
  __name: 'ESTBanner',
  setup(__props) {

const estBannerDismissed = ref(
  window.localStorage.getItem(estBannerLS) === 'true'
)

const estBannerFF = computed(() => getStateFeatureFlags()['ENABLE_EST_BANNER'])
const onBannerDismiss = () => {
  window.localStorage.setItem(estBannerLS, 'true')
  estBannerDismissed.value = true
  analytics.trackEvent(ANALYTICS_EVENTS.EST_BANNER_DISMISS)
}

const onCtaClick = () => {
  window.open(i18n.global.t('EST.banner.subsidiary_id_migration.URL'), '_blank')
  analytics.trackEvent(ANALYTICS_EVENTS.EST_BANNER_LINK_CLICK)
}

return (_ctx: any,_cache: any) => {
  return (estBannerFF.value && !estBannerDismissed.value)
    ? (_openBlock(), _createElementBlock("dsf-banner", {
        key: 0,
        dsf_dismissible: "",
        onDismiss: onBannerDismiss,
        dsf_title: _ctx.$t('EST.banner.subsidiary_id_migration.title')
      }, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('EST.banner.subsidiary_id_migration.description')) + " ", 1 /* TEXT */),
          _createElementVNode("dsf-link", {
            dsf_size: "medium",
            dsf_no_underline: "",
            onClick: _withModifiers(onCtaClick, ["stop","prevent"])
          }, _toDisplayString(_ctx.$t('EST.banner.subsidiary_id_migration.CTA')), 9 /* TEXT, PROPS */, _hoisted_2)
        ])
      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})